module.exports = __webpack_public_path__ + "media/images/credit-cards-4e56432a9c6c7e6ea97eb623862f465f.svg";